import React from "react";
import "./CTAButton.css";

const showDebugLines = false;

function CTAButton({ onClick, active= true, text, disabled = false }) {
    const buttonRef = React.useRef(null);
    const [debugInfo, setDebugInfo] = React.useState('');

    React.useEffect(() => {
        if (showDebugLines && buttonRef.current) {
            const styles = window.getComputedStyle(buttonRef.current);
            const width = styles.width;
            const fontSize = styles.fontSize;
            const vh = window.innerHeight;
            const tempDiv = document.createElement('div');
            tempDiv.style.height = '100vh';
            tempDiv.style.position = 'absolute';
            tempDiv.style.visibility = 'hidden';
            document.body.appendChild(tempDiv);
            const actualVh = tempDiv.offsetHeight;
            document.body.removeChild(tempDiv);
            setDebugInfo(`w:${width} fs:${fontSize} innerH:${vh}px vh:${actualVh}px`);
        }
    }, []);

    return (
        <>
            <div
                ref={buttonRef}
                onClick={!disabled && onClick}
                className={`cta-button ${ active && 'active'} ${ disabled && 'disabled'}`}
            >
                {showDebugLines && (
                    <div className="text-debug-lines">
                        <div className="text-debug-line text-debug-line-left"></div>
                        <div className="text-debug-line text-debug-line-right"></div>
                        <div className="horizontal-debug-line"></div>
                    </div>
                )}
                {text}
            </div>
            {showDebugLines && debugInfo && (
                <div style={{
                    position: 'absolute',
                    top: '-30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    color: 'yellow',
                    fontSize: '10px',
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }}>
                    {debugInfo}
                </div>
            )}
        </>
    );
}

export default CTAButton;
